import React, { useState, useEffect } from "react";
import {Row, Col, Button, Spinner, Popover, PopoverHeader, PopoverBody} from 'reactstrap';
import {useDispatch} from "react-redux";
import {executeRunbookStep} from "../../store/alertlog/actions";
import {Tooltip} from "recharts";

const TextInstructions = ({textInstruction, index, editable, sendDataToParent, id, type, code, runbook_id, runbook_created_at}) => {
  const [localText, setLocalText] = useState('');
  const [requestLoading, setRequestLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    setLocalText(textInstruction);
  }, [textInstruction]);

  const handleChange = (e) => {
    setLocalText(e.target.value);
  }

  const [tooltipOpen, setTooltipOpen] = useState(false);

  useEffect(() => {
    if (requestLoading) {
      const el = document.getElementById(`popover_target_${id}`);
      if (el) {
        setPopoverOpen(true);
      } else {
        setPopoverOpen(false);
      }
    } else {
      setPopoverOpen(false);
    }
  }, [requestLoading, id]);
  const togglePopover = () => {
    const el = document.getElementById(`popover_target_${id}`);
    if (el) {
      setPopoverOpen(prev => !prev);
    }
  }
  const toggleTooltip = () => {
    const el = document.getElementById(`tooltip_target_${id}_${runbook_id}`);
    if (el) {
      setTooltipOpen(prev => !prev);
    }
  };

  const [popoverOpen, setPopoverOpen] = useState(false);

  const handleSave = () => {
    let data={
      instruction: localText != '' ? localText : textInstruction,
      id: id,
      order: index+1,
    }
    sendDataToParent(data, type);
  }

  function executeRequest(id) {
    if(!runbook_id || !id){
      alert("Please save the runbook to execute the request")
    }
    else {
      const payload = {
        "runbook_id": runbook_id,
      }
      if(type === 'diagnostic'){
        payload['diagnostic_step_id'] = id
      } else if(type === 'recovery'){
        payload['recovery_step_id'] = id
      }
      setRequestLoading(true);
      dispatch(executeRunbookStep(payload))
      setTimeout(() => {
        setRequestLoading(false);
      }, 10000);
    }
  }

  return <React.Fragment>
      {editable ? 
        <Row className="mb-2">
          <Col className="mt-2" lg={1}>
            <p style={{fontSize:"15px", color:"#DBE1F5"}}>{`Step ${index+1}: `}</p>
          </Col>
          <Col lg={11}>
            <div style={{  minWidth: "0" }}>
            {!editable ?
              <div style={{color:"#DBE1F5"}}>{textInstruction}</div> :
              <input
                className="w-100 input"
                value={localText}
                onChange={handleChange}
                onBlur={handleSave}
                style={{ fontSize: "14px", minHeight: "10px", color:"#DBE1F5" }}
              />
            }
            </div>
          </Col>
        </Row> :
        <div className="d-flex">

          <div className={'d-flex me-1'}>
            <div
              className={`font-weight-bold d-flex align-items-center justify-content-between flex-row mb-1`}
              style={{fontSize:"15px", color:"#DBE1F5"}}
            >
              {`Step ${index+1}: `}
            </div>
          </div>
          <div style={{ flex: "1 1 75%", minWidth: "0" }}>
            {!editable ?
              <div className={'d-flex align-items-center justify-content-between flex-row mb-1'}>
                <div className={''} style={{ color:"#DBE1F5", fontSize: "15px"}}>{textInstruction}</div>
                <div>
                  {code && requestLoading ? (
                    <>
                      <Spinner
                        id={`popover_target_${id}`}
                        onMouseEnter={togglePopover}
                        onMouseLeave={togglePopover}
                        color={'primary'}
                        style={{ marginLeft: "5px", marginBottom: "5px" }}
                      />
                      {requestLoading && (
                        <Popover
                          placement="right-end"
                          isOpen={popoverOpen}
                          target={`popover_target_${id}`}
                          toggle={togglePopover}
                        >
                          <PopoverBody>Executing</PopoverBody>
                        </Popover>
                      )}
                    </>
                  ) : (
                    <>
                      {code && runbook_created_at && new Date(runbook_created_at) >= new Date('2025-05-13T09:09:15.464Z') && (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <i
                            onMouseEnter={toggleTooltip}
                            onMouseLeave={toggleTooltip}
                            id={`tooltip_target_${id}_${runbook_id}`}
                            className={'mdi mdi-information-outline'}
                            style={{ marginLeft: "4px", cursor: "pointer" }}
                          />
                          <Button
                            color={'primary'}
                            type={'submit'}
                            size={'sm'}
                            style={{ marginLeft: "5px", marginBottom: "5px" }}
                            onClick={() => executeRequest(id)}
                          >
                            Execute
                          </Button>
                          {!requestLoading && (
                            <Popover
                              placement="top"
                              isOpen={tooltipOpen}
                              target={`tooltip_target_${id}_${runbook_id}`}
                              toggle={toggleTooltip}
                            >
                              <PopoverBody>Will take few seconds to run.</PopoverBody>
                            </Popover>
                          )}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
               :
              <input
                className="w-100 form-control"
                value={localText}
                onChange={handleChange}
                onBlur={handleSave}
                style={{ fontSize: "15px", minHeight: "10px", color:"#DBE1F5", backgroundColor:"#222736" }}
              />
            }
          </div>
        </div>
      }
  </React.Fragment>
}

export default TextInstructions;